
import { supabase } from '../../config/supabase';
import { CreateNewsDto, News, UpdateNewsDto } from '../../types/news.types';
import { SupabaseService } from './SupabaseService';

export class NewsService extends SupabaseService {
  async getAllNews(page: number = 1, limit: number = 10) {
    try {
      // Calculate offset
      const offset = (page - 1) * limit;

      // Count total news
      const { count } = await supabase
        .from('news')
        .select('*', { count: 'exact', head: true });

      // Get news with pagination
      const { data, error } = await supabase
        .from('news')
        .select('*')
        .order('index', { ascending: true, })
        .order('created_at', { ascending: false })
        .range(offset, offset + limit - 1);

      if (error) throw error;

      return {
        news: data as News[],
        pagination: {
          total: count || 0,
          page,
          limit,
          totalPages: Math.ceil((count || 0) / limit)
        }
      };
    } catch (error) {
      console.error('Error fetching news:', error);
      throw error;
    }
  }

  async createNews(newsData: CreateNewsDto) {
    try {
      const { data, error } = await supabase
        .from('news')
        .insert([newsData])
        .select()
        .single();

      if (error) throw error;
      return data as News;
    } catch (error) {
      console.error('Error creating news:', error);
      throw error;
    }
  }

  async updateNews(id: string, newsData: UpdateNewsDto) {
    try {
      const { data, error } = await supabase
        .from('news')
        .update(newsData)
        .eq('id', id)
        .select()
        .single();

      if (error) throw error;
      return data as News;
    } catch (error) {
      console.error('Error updating news:', error);
      throw error;
    }
  }

  async deleteNews(id: string) {
    try {
      const { error } = await supabase
        .from('news')
        .delete()
        .eq('id', id);

      if (error) throw error;
      return true;
    } catch (error) {
      console.error('Error deleting news:', error);
      throw error;
    }
  }

  async getNewsById(id: string) {
    try {
      const { data, error } = await supabase
        .from('news')
        .select('*')
        .eq('id', id)
        .single();

      if (error) throw error;
      return data as News;
    } catch (error) {
      console.error('Error fetching news by ID:', error);
      throw error;
    }
  }
}
